import React, { useState, useEffect, useRef } from "react";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";

// In-memory image cache
const imageCache = new Map();

const BadgeImage = ({
  badgeName,
  altText = "Badge",
  style = {},
  width = 50,
  height = 50,
}) => {
  const pngPath = `/img/badges_images/${badgeName}_Indesign-certifikater.png`;

  const [loaded, setLoaded] = useState(false);
  const [src, setSrc] = useState(null);
  const imgRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      setLoaded(false);

      if (imageCache.has(pngPath)) {
        if (isMounted) {
          setSrc(imageCache.get(pngPath));
          setLoaded(true);
        }
        return;
      }

      const img = new Image();
      img.src = pngPath;
      img.onload = () => {
        if (isMounted) {
          imageCache.set(pngPath, pngPath);
          setSrc(pngPath);
          setLoaded(true);
        }
      };
      img.onerror = () => {
        if (isMounted) {
          console.error("Failed to load image:", pngPath);
          setLoaded(true); // Still hide skeleton, even on error
        }
      };
    };

    loadImage();

    return () => {
      isMounted = false;
    };
  }, [badgeName]);

  return (
    <>
      {!loaded ? (
        <Skeleton
          variant="rectangular"
          width={width}
          height={height}
          sx={{ borderRadius: "50%" }}
        />
      ) : (
        <Tooltip
          title={badgeName === "default" ? "No Badge" : badgeName?.replace(/\b\w/g, (c) => c.toUpperCase())}
          placement="top"
          arrow
        >
          <img
            ref={imgRef}
            src={src}
            alt={altText}
            width={width}
            height={height}
            style={{
              maxWidth: "100%",
              objectFit: "contain",
              ...style,
            }}
            loading="lazy"
            decoding="async"
            fetchpriority="low"
          />
        </Tooltip>
      )}
    </>
  );
};

export default React.memo(BadgeImage);
